<template>
  <vs-popup class="customer-site-create-popup"
            id="popup"
            title="CREATE CUSTOMER ACCOUNT CREDIT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="account_type" name="account_type" rules="required" v-slot="{ errors }">
                <small class="label">Account Type</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.account_type"  :options="['proforma','credit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div v-if="createForm.account_type === 'credit'" class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="current_credit_amount" name="current_credit_amount" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">
                <small class="label">Current Credit Balance ({{account_currency}})</small>
                <vs-input v-model="createForm.current_credit_amount"   name="current_credit_amount" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider vid="credit_limit" name="credit_limit" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">-->
<!--                <small class="label">Credit Limit ({{account_currency}})</small>-->
<!--                <vs-input v-model="createForm.credit_limit"   name="credit_limit" class="w-full required" label=""/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row mb-3" v-if="createForm.account_type === 'credit'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="credit_account_type" name="credit_account_type" rules="" v-slot="{ errors }">
                <small class="label">Credit Account Type</small>
                <v-select :clearable="false" placeholder="" v-model="createForm.credit_account_type"
                          :options="[{name: 'Standard', value: 'Standard'}, { name: 'EOM (End of Month)', value: 'EOM' }]"
                          :reduce="option => option.value"
                          label="name"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="['EOM', 'Standard'].includes(createForm.credit_account_type)">
              <ValidationProvider vid="credit_terms" name="credit_terms" rules="required" v-slot="{ errors }">
                <small class="label">Credit Terms (Days)</small>
                <vs-input v-model="createForm.credit_terms"   name="credit_terms" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {},
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: []
    }
  }

export default {
  name: 'CreateCustomerAccountCreditPopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: 'GBP',
    }
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
      } catch (error) {

      }
    },
    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.customer_id = this.id

         // format decimal places
         // this.createForm.credit_limit = (Number(this.createForm.credit_limit)).toFixed(2)
         this.createForm.current_credit_amount = (Number(this.createForm.current_credit_amount)).toFixed(2)

         await CustomerRepository.createCustomerAccountCredit(this.createForm)
         this.showSuccessMessage('Account credit created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  computed: {
    requiredAndTwoDecimalRules() {
      if (this.createForm.account_type === 'proforma') {
        return ''
      } else {
        return 'required'
      }
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
